import { createAction } from '@betty/toolkit/state';
import { DepositApprovedEventData } from './deposit.types';

export const openDeposit = createAction('deposit/open');

export const depositApproved =
  createAction<DepositApprovedEventData>('deposit/approved');
